import { render } from "./AFrontHeader.vue?vue&type=template&id=c161ad24&scoped=true"
import script from "./AFrontHeader.vue?vue&type=script&lang=js"
export * from "./AFrontHeader.vue?vue&type=script&lang=js"

import "./AFrontHeader.vue?vue&type=style&index=0&id=c161ad24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c161ad24"]])

export default __exports__